import {Button} from '@mui/material';
import React, {Fragment} from 'react';

import {Loading} from 'presentation/components/Loading/Loading';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {ActionsButtonsProps} from './types';

const {cancel} = translations['pt-br'].commons;
const {confirmAppointmentModal} = translations['pt-br'].privateFlow.myAppointments;

export function ActionsButtons({
	onCancel,
	onConfirm,
	isSubmitting,
	isDisabled,
}: ActionsButtonsProps) {
	return (
		<Fragment>
			<Button
				disabled={isSubmitting}
				fullWidth
				size="large"
				variant="outlined"
				onClick={onCancel}>
				{cancel}
			</Button>

			<Button
				disabled={isDisabled}
				fullWidth
				size="large"
				variant={'contained'}
				color={'primary'}
				onClick={onConfirm}
				endIcon={
					isSubmitting ? (
						<Loading size={20} color="inherit" />
					) : (
						<Icon name="success-date" />
					)
				}>
				{confirmAppointmentModal.actionButtonText}
			</Button>
		</Fragment>
	);
}
